import { useUnsavedChangesWarning } from '@app/core/hooks';
import { publishMessages } from '@app/modules/social-export/publish';
import { useFormState } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

/**
 * Warns before leaving when the publish form has unsaved edits.
 * Must render inside FormContainer so it can read RHF form state.
 * Skips the prompt while submitting so a successful publish can navigate away.
 */
export function PublishFormUnsavedChangesWarning() {
  const { $t } = useIntl();
  const { isDirty, isSubmitting } = useFormState();

  useUnsavedChangesWarning({
    isDirty: isDirty && !isSubmitting,
    message: $t(publishMessages.unsavedChangesLeavePrompt),
  });

  return null;
}
